__turbopack_context__.v({
  "link": "wHhISa_link",
  "title": "wHhISa_title",
});
